<ng-container *ngIf="error; else resultTpl">
  <nz-result nzStatus="error" nzTitle="Teamcenter gave an error" [nzSubTitle]="error"></nz-result>
</ng-container>

<ng-template #resultTpl>
  <nz-tabs class="em-tabs-vertical" nzTabPosition="left" *ngIf="itemStructure">
    <nz-tab
      *ngFor="let revision of itemStructure?.revisions; trackBy: trackByRef"
      [nzTitle]="revision.revId"
    >
      <nz-descriptions nzLayout="vertical">
        <nz-descriptions-item nzTitle="Revision">
          {{ revision.revId }}
        </nz-descriptions-item>
        <nz-descriptions-item nzTitle="Release status" nzSpan="2">
          <em-display-property [value]="revision.releaseStatus"></em-display-property>
        </nz-descriptions-item>
        <nz-descriptions-item nzTitle="Datasets" nzSpan="3">
          <em-dataset-card-list [datasets]="revision.datasets"></em-dataset-card-list>
        </nz-descriptions-item>
      </nz-descriptions>
    </nz-tab>
  </nz-tabs>
</ng-template>
